module.exports = __webpack_public_path__ + "img/8-twoImg.9d39acc5.png";